import { JsonObject, JsonProperty } from 'json2typescript';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';
import { Assistants } from './assistants';
import { Initiators } from './initiators';
import { MeetingDetailsInterface } from 'src/app/core/domain/data/meeting-details.interface';

@JsonObject('MeetingDetails')
export class MeetingDetails implements MeetingDetailsInterface {
  @JsonProperty('Date', StringAdapter, true)
  private _date: string = undefined;

  @JsonProperty('Place', StringAdapter, true)
  private _place: string = undefined;

  @JsonProperty('Notes', StringAdapter, true)
  private _notes: string = undefined;

  @JsonProperty('Assistants', [Assistants], true)
  private _assistants: Assistants[] = [];

  @JsonProperty('Initiators', [Initiators], true)
  private _initiators: Initiators[] = [];

  constructor() {}

  get date(): string {
    return this._date;
  }

  set date(value: string) {
    this._date = value;
  }

  get place(): string {
    return this._place;
  }

  set place(value: string) {
    this._place = value;
  }

  get notes(): string {
    return this._notes;
  }

  set notes(value: string) {
    this._notes = value;
  }

  get assistants(): Assistants[] {
    if (!this._assistants) {
      this._assistants = [];
    }
    return this._assistants;
  }

  set assistants(value: Assistants[]) {
    this._assistants = value;
  }

  get initiators(): Initiators[] {
    if (!this._initiators) {
      this._initiators = [];
    }
    return this._initiators;
  }

  set initiators(value: Initiators[]) {
    this._initiators = value;
  }
}
